<template>
    <main>
        <agile :navButtons=false>
            <img class="slide" src="http://www.shengjia-resin.com/temp/1.jpg" />
            <img class="slide" src="http://www.shengjia-resin.com/temp/2.jpg" />
            <img class="slide" src="http://www.shengjia-resin.com/temp/3.jpg" />
        </agile>
        <div class="article-wrapper">
            <article>
                <div class="about-wrapper">
                    <baidu-map class="bm-view" :center="{lng: 120.675212, lat: 31.322198}" :zoom="15" ak="OBzFACl471LVPwzsIrapHEv2">
                    </baidu-map>
                    <div class="content-text" v-html="content"></div>
                </div>
            </article>
        </div>
    </main>
</template>

<script>

    import qs from 'qs'
    import BaiduMap from 'vue-baidu-map/components/map/Map.vue'
    import {
        VueAgile
    } from 'vue-agile'
    export default {
        name: 'Contact',
        components: {
            BaiduMap,
            agile: VueAgile
        },
        data() {
            return {
                content: '',
                datas: {},
                type: '联系我们'
            }
        },
        mounted() {
            this.loadData();
        },
        methods: {
            loadData() {
                this.$axios.post('/findCompanyByType', qs.stringify({companyType:this.type})).then(res => {
                    this.datas = res.data;
                    if (this.datas != null) {
                        this.content = this.datas.content;
                    }
                }).catch(res => {
                    alert("数据获取失败")
                })
            }
        }
    }
</script>

<style lang="less">
    .bm-view {
        width: 400px;
        height: 300px;
        margin-right: 40px;
        flex-shrink: 0;
    }

    .about-wrapper {
        display: flex;
        align-items: center;
    }

    .content-text tr {
        height: 25px;
    }

    .content-text tr > td:nth-child(2) {
        position: relative;
        left: -68px;
    }
</style>